import type { IIntakeConfig } from '../intakeConfigService/types';

export interface IDiagnoses {
  diagnosisDescription: string;
  icdCode: string;
  displayTitle?: string;
}

export interface ITocOption {
  uuid: string;
  therapyType: number;
  displayName: string;
}

export interface IIntakeData {
  diagnoses?: IDiagnoses[];
  config: IIntakeConfig;
  joinCodes?: Record<string, string>;
  payorOptions: { value: number; displayText: string }[];
  locations: string[];
  isAllowedToTreat?: boolean;
  tocOptions: ITocOption[];
}

export interface ISurgeryInfo {
  surgeryType: string | null;
  surgeryDate: string;
  id?: string;
}

export interface INewPatientData {
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  gender: number;
  address: string;
  height: number;
  weight: number;
  diagnosis: string[];
  assistiveDevice: string;
  mainAffectedArea: string;
  affectedSide: string;
  fallDate?: string | null;
  surgeries: ISurgeryInfo[];
  nonAmbulatory: boolean | string | null;
  kLevel: number | string | null;
  emrNumber: string;
  caseNumber: string;
  typeOfCareUuid: string | null;
  payor: number | null;
  phoneNumber: string;
  assignPt: boolean;
  poa: boolean;
  careLocation: string | null;
  setRtm: boolean;
  inch?: number;
}

export enum smsSentStatusEnum {
  initial,
  inProgress,
  Done,
  Cancelled,
}
